import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const UPDATE_PASSWORD = "updatePassword";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";
export const SET_USER = "setVerify";

const state = {
  errors: {},
  user: {},
  message: null,
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },

  isAuthenticated(state) {
    return state.isAuthenticated;
  },

  errorsUser(){
    return state.errors;
  },

  errorsMessageUser(){
    return state.message;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("/user/login", credentials)
        .then(({ data }) => {
          resolve(data);
          context.commit(SET_AUTH, data.access_token);
        })
        .catch(({ response }) => {
          reject(response);
          context.commit(SET_ERROR, response.data);
        });
    });
  },

  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },

  [REGISTER](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("users", { user: credentials })
        .then(({ data }) => {
          resolve(data);
          context.commit(SET_AUTH, data);

        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return new Promise((resolve, reject) => {
      ApiService.get("/user/current")
        .then(({ data }) => {
          resolve(data);
          context.commit(SET_USER, data);
        })
        .catch(({ response }) => {
          reject(response);
          context.commit(SET_ERROR, response.data);
          context.commit(PURGE_AUTH);
        });
      });
    } else {
      context.commit(PURGE_AUTH);
    }
  },

  [UPDATE_USER](context, credentials) {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        ApiService.post("/user/change-profile", credentials)
            .then(({ data }) => {
              context.commit(SET_ERROR, {});
              context.dispatch(VERIFY_AUTH);
              resolve(data);
            })
            .catch(({ response }) => {
              if (response.status === 422){
                context.commit(SET_ERROR, response.data);
              }
              reject(response);
            });
      });
    } else {
      context.commit(PURGE_AUTH);
    }

  },

  [UPDATE_PASSWORD](context, credentials) {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        ApiService.post("/user/change-password", credentials)
            .then(({ data }) => {
              context.commit(SET_ERROR, {});
              resolve(data);
            })
            .catch(({ response }) => {
              if (response.status === 422){
                context.commit(SET_ERROR, response.data);
              }
              reject(response);
            });
      });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error.errors;
    state.message = error.message;
  },

  [SET_AUTH](state, token) {
    state.isAuthenticated = true;
    JwtService.saveToken(token);
  },

  [SET_USER](state, user) {
    state.user = user.data;
    state.errors = {};
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    state.message = null;
    JwtService.destroyToken();

  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
